// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import { baseIcon, defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
import { isWaffle, isWhiteLabel } from '@bubble-ui/particle-design-versions';
var IconClosePathPancake = 'M10.872 10.004c.449-.14.875-.373 1.23-.729l5.602-5.601L16.29 2.26l-5.602 5.601a.999.999 0 0 1-1.414 0l-5.57-5.57L2.29 3.705l5.57 5.57c.364.364.8.6 1.261.738a2.86 2.86 0 0 0-1.229.708L2.29 16.322l1.414 1.414 5.603-5.601a1.022 1.022 0 0 1 1.413 0l5.57 5.57 1.414-1.414-5.57-5.57a2.869 2.869 0 0 0-1.262-.717Z';
var IconClosePathWaffle = 'M17.047 4.13 15.87 2.954 10 8.822l-5.87-5.87-1.178 1.179L8.822 10l-5.87 5.87 1.179 1.178L10 11.178l5.87 5.87 1.178-1.179L11.177 10l5.87-5.87Z';
var IconClosePathWaffleFilled = 'M17.047 4.13 15.87 2.954 10 8.822l-5.87-5.87-1.178 1.179L8.822 10l-5.87 5.87 1.179 1.178L10 11.178l5.87 5.87 1.178-1.179L11.177 10l5.87-5.87Z';
var IconClosePathWhiteLabel = 'M17.047 4.131 15.87 2.953 10 8.822l-5.868-5.87-1.179 1.179 5.87 5.87-5.87 5.868 1.179 1.179L10 11.178l5.87 5.87 1.177-1.179L11.178 10l5.87-5.869Z';
var IconClosePathWhiteLabelFilled = 'M17.047 4.13 15.87 2.953 10 8.822l-5.868-5.87-1.179 1.179L8.822 10l-5.87 5.869 1.179 1.178L10 11.178l5.87 5.87 1.177-1.18L11.178 10l5.87-5.87Z';
var IconCloseViewBoxWaffle = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconCloseViewBoxWaffleFilled = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconCloseViewBoxWhiteLabel = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconCloseViewBoxWhiteLabelFilled = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
export var IconClose = baseIcon('IconClose', {
  groupProps: defaultIconGroupProps,
  getPath: _ref => {
    var {
      designVersion,
      filled
    } = _ref;
    return isWhiteLabel(designVersion) ? filled ? IconClosePathWhiteLabelFilled : IconClosePathWhiteLabel : isWaffle(designVersion) ? filled ? IconClosePathWaffleFilled : IconClosePathWaffle : IconClosePathPancake;
  },
  shapeSize: _ref2 => {
    var {
      designVersion,
      filled
    } = _ref2;
    return isWhiteLabel(designVersion) ? filled ? IconCloseViewBoxWhiteLabelFilled : IconCloseViewBoxWhiteLabel : isWaffle(designVersion) ? filled ? IconCloseViewBoxWaffleFilled : IconCloseViewBoxWaffle : {};
  }
});
//# sourceMappingURL=index.js.map